module.exports = __webpack_public_path__ + "static/media/Avatars_Male-17.a61f88f5.png";